var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.25C5.07 22.25 0.25 17.43 0.25 11.5C0.25 5.57 5.07 0.75 11 0.75C16.93 0.75 21.75 5.57 21.75 11.5C21.75 17.43 16.93 22.25 11 22.25ZM11 2.25C5.9 2.25 1.75 6.4 1.75 11.5C1.75 16.6 5.9 20.75 11 20.75C16.1 20.75 20.25 16.6 20.25 11.5C20.25 6.4 16.1 2.25 11 2.25Z",
    fill: "#4786FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25H7C6.59 12.25 6.25 11.91 6.25 11.5C6.25 11.09 6.59 10.75 7 10.75H15C15.41 10.75 15.75 11.09 15.75 11.5C15.75 11.91 15.41 12.25 15 12.25Z",
    fill: "#4786FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.25C10.59 16.25 10.25 15.91 10.25 15.5V7.5C10.25 7.09 10.59 6.75 11 6.75C11.41 6.75 11.75 7.09 11.75 7.5V15.5C11.75 15.91 11.41 16.25 11 16.25Z",
    fill: "#4786FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRequest);
export default __webpack_public_path__ + "static/media/create-request.c4e35048beabbc4c7b9ce0208c43ab32.svg";
export { ForwardRef as ReactComponent };